import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import { createAction } from '@reduxjs/toolkit'

import { Theme } from './reducer'
// import { TokenList } from '@uniswap/token-lists'

// export type PopupContent =
//   | {
//       txn: {
//         hash: string
//         success: boolean
//         summary?: string
//       }
//     }
// | {
//     listUpdate: {
//       listUrl: string
//       oldList: TokenList
//       newList: TokenList
//       auto: boolean
//     }
//   }

// export enum ApplicationModal {
// SETTINGS,
// LANGUAGE,
//   SETTINGS,
//   SELF_CLAIM,
//   ADDRESS_CLAIM,
//   CLAIM_POPUP,
//   MENU,
//   DELEGATE,
//   VOTE,
//   LANGUAGE,
//   NETWORK,
//   CHAIN,
//   EMBER_STATS,
//   BCH_STATS,
//   YIELD_DETAILS,
// }

export const updateBlockNumber = createAction<{
  chainId: number
  blockNumber: number
}>('application/updateBlockNumber')
export const updateChainId = createAction<{
  chainId: ChainId
}>('application/updateChainId')
export const updateTheme = createAction<{
  theme: Theme
}>('application/updateTheme')
export const updateLanguage = createAction<{
  language: string
}>('application/updateLanguage')
export const updateConnect = createAction<{
  connect: boolean
}>('application/updateConnect')
// export const setModal = createAction<ApplicationModal.SETTINGS | null>('application/setModal')
// export const addPopup = createAction<{
//   key?: string
//   removeAfterMs?: number | null
//   content: PopupContent
// }>('application/addPopup')
// export const removePopup = createAction<{ key: string }>('application/removePopup')
// export const setKashiApprovalPending = createAction<string>('application/setKashiApprovalPending')
